import env from '@upgrade/ui-utils/env';
function consoleDeprecated(message) {
  if (env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`upgrade-react-components: ${message}`);
  }
}
export default consoleDeprecated;
//# sourceMappingURL=console-deprecated.js.map